import React, { useRef, useState } from "react"
import { motion } from "framer-motion"
import useApp from "hooks/useApp"

const Floater = ({ children }) => {
    const App = useApp()
    const win = useRef()
    const [show, setShow] = useState(true)
    const [fold, setFold] = useState(true)

    const onFold = () => {
        setFold(prev => !prev)
    }

    const onClose = (e) => {
        setShow(false)
    }

    if (App.test) {
        return (
            show && (
                <motion.div className={`floater${fold ? " fold" : ""}`} drag ref={win}>
                    <div className='close' onClick={onClose} />
                    <div className='btn' onClick={onFold}>
                        <div className='hori' />
                        <div className='ver' />
                    </div>
                    <ul>{children}</ul>
                </motion.div>
            )
        )
    } else {
        return <></>
    }
}
export default Floater
